// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container {\n  margin-bottom: 10px;\n}\n", "",{"version":3,"sources":["webpack://./src/app/relaties/factuuradressen/factuuradressenlist/factuuradressenlist.component.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF","sourcesContent":[".container{\n  margin-bottom: 10px;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
